import React, { createContext } from 'react'

export interface ModalProps<T> {
  cancelModal: () => void
  setModalSuccess: (value: T) => void
}

export type OpenModal = <T>(render: (controls: ModalProps<T>) => React.ReactNode) => Promise<T>

interface ModalContextType {
  openModal: OpenModal
}

export const ModalContext = createContext<ModalContextType | null>(null)
